/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientAddress
 */
export interface PccPatientAddress {
    /**
     * 
     */
    address_line1?: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    zip?: string;
    /**
     * 
     */
    country?: string;
}

/**
 * Check if a given object implements the PccPatientAddress interface.
 */
export function instanceOfPccPatientAddress(value: object): value is PccPatientAddress {
    return true;
}

export function PccPatientAddressFromJSON(json: any): PccPatientAddress {
    return PccPatientAddressFromJSONTyped(json, false);
}

export function PccPatientAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'address_line1': json['address_line1'] == null ? undefined : json['address_line1'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function PccPatientAddressToJSON(json: any): PccPatientAddress {
    return PccPatientAddressToJSONTyped(json, false);
}

export function PccPatientAddressToJSONTyped(value?: PccPatientAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address_line1': value['address_line1'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
    };
}

